type CloseFn = () => void

const registry = new Set<CloseFn>()

export const registerPopover = (close: CloseFn) => {
  registry.add(close)

  return () => {
    registry.delete(close)
  }
}

export const hideAllPopovers = () => {
  registry.forEach((close) => {
    close()
  })
}
